import { rem } from 'polished';
import styled from 'styled-components';

import { IHamburgerProps } from './Hamburger.types';

export const StyledButton = styled.button<IHamburgerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${rem('24px')};
  width: ${rem('24px')};
  padding: ${rem('8px')};
  background-color: transparent;
  border: none;
  box-sizing: content-box;
  appearance: none;

  svg {
    height: auto;
    width: ${({ active }) => (active ? rem('13px') : rem('16px'))};
  }
`;
